import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';

import { InitPage } from './pages/internal/init/init';
import { PollPage } from './pages/internal/poll/poll';
import { DashboardPage } from './pages/internal/dashboard/dashboard';
import { PageQR } from './pages/internal/page-qr/page-qr';
import { PageCheck } from './pages/internal/page-check/page-check';
import { ListTask } from './pages/task/list-task/list-task';
import { Login } from './pages/login/login';
import { AdminPage } from './pages/internal/admin/admin';
import { ChangePasswordPage } from './pages/change-password/change-password';
import { HomeTaskPage } from './pages/task/home/home';
import { MaintenancePage } from './pages/task/maintenance/maintenance';
import { ProductionPage } from './pages/task/production/production';
import { ActivityPage } from './pages/task/activity/activity';
import { StandardPage } from './pages/task/standard/standard';


const routes: Routes = [
//  { path: '', redirectTo: '/login', pathMatch: 'full' },

  //covid
  { path: '', redirectTo: '/iniciar', pathMatch: 'full' },
  { path: 'iniciar', component: InitPage, data: { title: 'Iniciar'} },
  { path: 'ingresos', component: PollPage, data: { title: 'Gestión Ingresos'} },
  { path: 'ingresos/:tipoUsuario/:rut', component: PollPage, data: { title: 'Gestión Ingresos'} },
  { path: 'qr/:codigo', component: PageQR, data: { title: 'Gestión Ingresos'} },
  { path: 'check/:rut', component: PageCheck, data: { title: 'Gestión Ingresos'} },
  { path: 'tareas', component: ListTask, data: { title: 'Gestión Tareas'} },
  { path: 'login', component: Login, data: { title: 'Login'} },
  { path: 'administrador', component: AdminPage, data: { title: 'Gestión Ingresos'} },
  { path: 'cambiarClave', component: ChangePasswordPage, data: { title: 'Cambiar clave'} },
  { path: 'gestionTareas', component: HomeTaskPage, data: { title: 'Gestión de tareas'} },
  { path: 'mantenciones', component: MaintenancePage, data: { title: 'Mantenciones'} },
  { path: 'actividades', component: ActivityPage, data: { title: 'Actividades'} },
  { path: 'produccion', component: ProductionPage, data: { title: 'Producción'} },
  { path: 'estandares', component: StandardPage, data: { title: 'Producción'} },

];

@NgModule({
  imports: [ CommonModule, RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  declarations: []
})


export class AppRoutingModule { }
